import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=910f90a8&"
import script from "./forgotPassword.vue?vue&type=script&lang=ts&"
export * from "./forgotPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports